import * as Models from "../.";

export interface ISolarCustomerDetailsResponse {
    customer: Models.Customer.Customer.Customer;
    serviceAddress: Models.Customer.VerifiedAddress.VerifiedAddress;
    billingAddress: Models.Customer.Address.Address;
    primaryEmail: string;
    primaryPhone: string;
    hasInvoice: boolean;
    hasTransactions: boolean;
    hasSystem: boolean;
    isActive: boolean;
    installer: string;
    contractAmendmentNameInProgress: boolean;
    contractAmendmentAddressInProgress: boolean;
    contractAmendmentTrustInProgress: boolean;
    contractAmendmentNoTrustInProgress: boolean;
    pendingNameForContractAmendment: string;
    pendingAddressForContractAmendment: string;
    pendingTrustNameForContractAmendment: string;
    contractAmendmentRateInProgress: boolean;
    productCode: string;
    safeHarborContractMethodDeadline: string;
    contractOutsideOfValueProp: boolean;
    contractRecisionExpiryDate: string;
    salesPartner: string;
    contractAmendmentRequired: boolean;
    designatedHoldbackDeadline?: Date;
    projectedCancellationDeadline?: Date;
}

export class SolarCustomerDetailsResponse implements ISolarCustomerDetailsResponse {
    public customer: Models.Customer.Customer.Customer;
    public serviceAddress: Models.Customer.VerifiedAddress.VerifiedAddress;
    public billingAddress: Models.Customer.Address.Address;
    public primaryEmail: string;
    public primaryPhone: string;
    public hasInvoice: boolean;
    public hasTransactions: boolean;
    public hasSystem: boolean;
    public isActive: boolean;
    public installer: string;
    public contractAmendmentRateInProgress: boolean;
    public contractAmendmentNameInProgress: boolean;
    public contractAmendmentAddressInProgress: boolean;
    public contractAmendmentTrustInProgress: boolean;
    public contractAmendmentNoTrustInProgress: boolean;
    public pendingNameForContractAmendment: string;
    public pendingAddressForContractAmendment: string;
    public pendingTrustNameForContractAmendment: string;
    public productCode: string;
    public safeHarborContractMethodDeadline: string;
    public contractOutsideOfValueProp: boolean;
    public contractRecisionExpiryDate: string;
    public salesPartner: string;
    public contractAmendmentRequired: boolean;
    public designatedHoldbackDeadline?: Date;
    public projectedCancellationDeadline?: Date;
}
